<full-calendar
  [options]="calendarOptions" [resources]="resources" [events]="events">
</full-calendar>
